<template>
  <div id="wrapper">
    <SidebarView :members="true" :add-member="true" :member-visible="true" />
    <div class="d-flex flex-column" id="content-wrapper">
      <div id="content">
        <TopbarView />
        <form @submit.prevent="submitMember()" :add_or_edit="add_or_edit">
          <div class="container-fluid">
            <div class="row pb-2">
              <div class="col-md-3">
                <button type="submit" class="btn akkurate-green-btn text-white btn-size my-2 me-2">
                  <font-awesome-icon class="me-2" :icon="['fas', 'save']" />Update
                </button>
              </div>
            </div>
            <div class="row mb-4">
              <div class="general-error d-flex justify-content-center pt-2 pb-2">
                <errors v-if="error_msg">
                  {{ error_msg }}
                </errors>
              </div>
              <div class="col-12 col-md-12">
                <div class="card card-shape home-box">
                  <div class="card-header d-flex flex-row align-items-center">
                    <h6 class="m-0 fw-bold text-green">Personal Details</h6>
                  </div>
                  <div class="card-body">
                    <personal-details :form="form" :add_or_edit="add_or_edit"
                      :users_option="users_option"></personal-details>
                    <div class="row mt-2">
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <label class="akkurate-dark d-flex justify-content-between small mb-2" for="profile_picture">
                            <div>Passport Picture <star></star>
                            </div>
                            <a class="btn btn-sm akkurate-danger-btn" @click="removeFile('profile')"><span
                                class="akkurate-small text-white">
                                <font-awesome-icon :icon="['fas', 'trash']" /></span></a>
                          </label>
                          <b-form-group id="choose_file" label-for="choose_file">
                            <vue-dropzone ref="profileDropzone" @vdropzone-files-added="onProfilePictureUpload"
                              id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                          </b-form-group>
                          <!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
                          <errors v-if="form.errors.profile_picture">
                            {{ form.errors.profile_picture[0] }}
                          </errors>
                        </div>
                      </div>
                      <div class="col-12  col-md-3">
                        <div class="form-group">
                          <label class="akkurate-dark d-flex justify-content-between small mb-2" for="ghana_card_front">
                            <div>Ghana Card (Front) <star></star>
                            </div>
                            <a class="btn btn-sm akkurate-danger-btn" @click="removeFile('ghanaCardFront')"><span
                                class="akkurate-small text-white">
                                <font-awesome-icon :icon="['fas', 'trash']" /></span></a>
                          </label>
                          <b-form-group id="choose_file" label-for="choose_file">
                            <vue-dropzone ref="ghanaCardFrontDropzone" @vdropzone-files-added="onGhanaCardFrontUpload"
                              id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                          </b-form-group>
                          <!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
                          <errors v-if="form.errors.gh_card_front_path">
                            {{ form.errors.gh_card_front_path[0] }}
                          </errors>
                        </div>
                      </div>
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <label class="akkurate-dark d-flex justify-content-between small mb-2" for="ghana_card_back">
                            <div>Ghana Card (Back) <star></star>
                            </div>
                            <a class="btn btn-sm akkurate-danger-btn" @click="removeFile('ghanaCardBack')"><span
                                class="akkurate-small text-white">
                                <font-awesome-icon :icon="['fas', 'trash']" /></span></a>
                          </label>
                          <b-form-group id="choose_file" label-for="choose_file">
                            <vue-dropzone ref="ghanaCardBackDropzone" @vdropzone-files-added="onGhanaCardBackUpload"
                              id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                          </b-form-group>
                          <!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
                          <errors v-if="form.errors.gh_card_back_path">
                            {{ form.errors.gh_card_back_path[0] }}
                          </errors>
                        </div>
                      </div>
                      <div class="col-12 col-md-3">
                        <div class="form-group">
                          <label class="akkurate-dark d-flex justify-content-between small mb-2" for="signature">
                            <div>Signature (Max. 2.5MB)<star></star>
                            </div>
                            <a class="btn btn-sm akkurate-danger-btn" @click="removeFile('signature')"><span
                                class="akkurate-small text-white">
                                <font-awesome-icon :icon="['fas', 'trash']" /></span></a>
                          </label>
                          <b-form-group id="choose_file" label-for="choose_file">
                            <vue-dropzone ref="signatureDropzone" @vdropzone-files-added="onSignatureUpload"
                              id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                          </b-form-group>
                          <!-- <label>Authorization Letter</label>
                                      <input type="file" class="form-control" @change="handleAuthorizationLetter"> -->
                          <errors v-if="form.errors.signature">
                            {{ form.errors.signature[0] }}
                          </errors>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-12 col-md-12">
                <div class="card card-shape home-box">
                  <div class="card-header d-flex flex-row align-items-center">
                    <h6 class="m-0 fw-bold text-green">Employment Details</h6>
                  </div>
                  <div class="card-body">
                    <employer-details :form="form" :add_or_edit="add_or_edit"></employer-details>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-12 col-md-12">
                <div class="card card-shape home-box">
                  <div class="card-header d-flex flex-row align-items-center">
                    <h6 class="m-0 fw-bold text-green">Financial Information</h6>
                  </div>
                  <div class="card-body">
                    <financial-information :form="form" :add_or_edit="add_or_edit"></financial-information>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-12 mt-2 mt-md-0 col-md-12">
                <div class="card card-shape home-box">
                  <div class="card-header d-flex flex-row align-items-center">
                    <h6 class="m-0 fw-bold text-green">Address</h6>
                  </div>
                  <div class="card-body">
                    <address-view :region_options="regions" :form="form" :branch_options="branches"
                      :add_or_edit="add_or_edit"></address-view>
                  </div>
                  <hr />
                  <div class="text-center py-3">
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-12 col-md-12">
                <div class="card card-shape home-box">
                  <div class="card-header d-flex flex-row align-items-center">
                    <h6 class="m-0 fw-bold text-green">Spouse Details</h6>
                  </div>
                  <div class="card-body">
                    <spouse-details :form="form" @responseFront="handleResponseFront" @responseBack="handleResponseBack"
                      @responsePassportPic="responsePassportPic" @responseSignaturePic="responseSignaturePic"
                      :add_or_edit="add_or_edit"></spouse-details>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-12 col-md-12">
                <div class="card card-shape home-box">
                  <div class="card-header d-flex flex-row align-items-center"
                    style="display: flex;justify-content: space-between;">
                    <div class="">
                      <h6 class="m-0 fw-bold text-green">Reference Details / In-Trust Of</h6>
                    </div>
                    <div class="">
                      <span>
                        <h6>In case of an emergency</h6>
                      </span>
                    </div>
                  </div>
                  <div class="card-body">
                    <emergency-contact-details :form="form" :add_or_edit="add_or_edit"></emergency-contact-details>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="col-md-3">
                  <button type="submit" class="btn akkurate-green-btn text-white btn-size my-2 me-2">
                    <font-awesome-icon class="me-2" :icon="['fas', 'save']" /> Update
                  </button>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
      <footer></footer>
    </div>
  </div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import Footer from "@/views/main/components/Footer.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import AddressView from "../forms/Address";
import PersonalDetails from "../forms/PersonalDetails";
import EmployerDetails from "../forms/EmployerDetails";
import FinancialInformation from "../forms/FinancialInformation";
import SpouseDetails from "../forms/SpouseDetails";
import EmergencyContactDetails from "../forms/EmergencyContactDetails";
// import AddAccount from "../forms/Modal/AddAccount";
// import NextOfKin from "../forms/Modal/NextOfKin.vue";
import ApiService from "@/core/services/api.service";
import vueDropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  name: "MemberEdit",
  mounted() {
    this.loadPageOptions();
    this.mountMemberData();
  },
  components: {
    SidebarView,
    Footer,
    TopbarView,
    AddressView,
    PersonalDetails,
    // AddAccount,
    // NextOfKin,
    EmployerDetails,
    FinancialInformation,
    SpouseDetails,
    EmergencyContactDetails,
    vueDropzone,
  },
  data() {
    return {
      users_option: [],
      front_card_path: "",
      front_card_name: "",
      back_card_path: "",
      back_card_name: "",
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 100,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" }
      },

      form: {
        accounts: [],
        nextofkins: [],
        first_name: "",
        middlename: null,
        last_name: "",
        title: "",
        email: "",
        mobile: "",
        gender: "",
        date_of_birth: "",
        external_code: "",
        marital_status: "",
        address: "",
        digital_address: "", //not required
        home_town: "", //not required
        landmark: "",
        region: {},
        branch: {},
        employer_name: null, //not required
        ghana_card_number: null, //not required
        status: "",
        errors: [],
        gh_card_back_display: null,
        gh_card_front_display: null,
        passport_pic_display: null,
        signature_display: null,
        employer_address: null,
        employer_mobile: null,
        occupation: null,
        employee_position: null,
        source_of_funds: null,
        bankers_name: null,
        bankers_address: null,
        bankers_location: null,
        monthly_salary: null,
        signature_image_path: null,
        signature_image_name: null,
        passport_pic_path: null,
        passport_pic_name: null,
        note: null,
        mandate: null,
        customer_type: null,
        bank_account_number: null,
        nearest_landmark: null,
        spouse_name: null,
        spouse_phone: null,
        spouse_email: null,
        spouse_address: null,
        mobile_secondary: null,
        employment_status: null,
        reference_name: null,
        reference_phone: null,
        reference_email: null,
        reference_address: null,
        ro: "",
        place_of_work: "",
      },
      error_msg: "",
      regions: [],
      branches: [],
      account_types: [],
      add_or_edit: 'edit',
      front_card_path: "",
      front_card_name: "",
      back_card_path: "",
      back_card_name: "",
    };
  },

  methods: {
    async loadPageOptions() {
      this.$Progress.start();
      await ApiService.get("/customers/dropdown")
        .then((response) => {
          this.account_types = response.data.account_types;
          this.regions = response.data.regions;
          this.branches = response.data.branches;
          this.users_option = response.data.users;
          this.isLoading = false;
          // $emit('coa-head-saved', response.data)
          this.$Progress.finish();
        })
        .catch((error) => {
          this.isLoading = false;
          this.$Progress.fail();
        });
    },
    async mountMemberData() {
      await ApiService.get(`/customers/view/${this.$route.params.id}`)
        .then((response) => {
          // console.log(response.data.data);
          let data = response.data.data;
          this.form.title = data.title;
          this.form.first_name = data.first_name;
          this.form.middlename = data.middlename;
          this.form.last_name = data.last_name;
          this.form.gender = data.gender;
          this.form.date_of_birth = data.date_of_birth;
          this.form.marital_status = data.marital_status;
          this.form.email = data.email;
          this.form.mobile = data.mobile;
          this.form.ghana_card_number = data.ghana_card_number;
          this.form.status = data.status;
          this.form.staff_id = data.staff_id;
          this.form.branch = data.branch;
          this.form.region = data.region
          this.form.address = data.address;
          this.form.digital_address = data.digital_address;
          this.form.home_town = data.home_town;
          this.form.external_code = data.external_code;
          this.form.customer_type = data.customer_type;
          this.form.bank_account_number = data.bank_account_number;
          this.form.mandate = data.mandate;
          this.form.note = data.note;
          this.form.employer_name = data.employer_name;
          this.form.employer_address = data.employer_address;
          this.form.employer_mobile = data.employer_mobile;
          this.form.occupation = data.occupation;
          this.form.employee_position = data.employee_position;
          this.form.source_of_funds = data.source_of_funds;
          this.form.bankers_name = data.bankers_name;
          this.form.bankers_address = data.bankers_address;
          this.form.bankers_location = data.bankers_location;
          this.form.monthly_salary = data.monthly_salary;
          this.form.spouse_name = data.spouse_name;
          this.form.spouse_mobile = data.spouse_mobile;
          this.form.spouse_email = data.spouse_email;
          this.form.spouse_address = data.spouse_address;
          this.form.mobile_secondary = data.mobile_secondary;
          this.form.employment_status = data.employment_status;
          this.form.reference_name = data.reference_name;
          this.form.reference_mobile = data.reference_mobile;
          this.form.reference_email = data.reference_email;
          this.form.reference_address = data.reference_address;
          this.form.nearest_landmark = data.nearest_landmark;
          this.form.ro = data.ro;


          this.form.unapproved_withdrawal_max_amount = data.unapproved_withdrawal_max_amount;
          if (data.gh_card_back_path) {
            this.form.gh_card_back_display = data.gh_card_back_path;
          }

          if (data.gh_card_front_path) {
            this.form.gh_card_front_display = data.gh_card_front_path;
          }

          if (data.passport_pic_path) {
            this.form.passport_pic_display = data.passport_pic_path;
          }

          if (data.signature_image_path) {
            this.form.signature_display = data.signature_image_path;
          }
        }).catch((error) => {

        })

    },
    async submitMember() {
      this.isSaving = true;
      this.$Progress.start();


      // this.form.gh_card_front_path = this.front_card_path;
      // this.form.gh_card_front_name = this.front_card_name;
      // this.form.gh_card_back_path = this.back_card_path;
      // this.form.gh_card_back_name = this.back_card_name;

      await this.uploadImage().then(async () => {
        await ApiService.put(`/customers/update/${this.$route.params.id}`, this.form)
          .then((response) => {
            this.isSaving = false;
            this.$Progress.finish();
            toast.fire({
              icon: "success",
              title: response.data.message,
            });
            setTimeout(() => {
              window.location.href = "/members";
            }, '1000');


          })
          .catch((error) => {
            this.isSaving = false;
            this.$Progress.fail();
            this.form.errors = [];
            if (error.response?.data?.errors) {
              console.log(error.response.data.errors);
              this.form.errors = error.response.data.errors;
            }
            this.error_msg = error.response.data.message
            // console.log(error.response.data)
          });
      })



    },
    handleResponseFront(message) {
      // console.log(message);
      this.front_card_path = message.front_ghana_path;
      this.front_card_name = message.front_ghana_name;
    },
    handleResponseBack(message) {
      // console.log(message);
      this.back_card_path = message.back_ghana_path;
      this.back_card_name = message.back_ghana_name;
    },
    responseSignaturePic(obj) {
      // console.log(obj);
      this.form.signature_image_path = obj.signature_image_path;
      this.form.signature_image_name = obj.signature_image_name;
    },
    responsePassportPic(obj) {
      // console.log(obj);
      this.form.passport_pic_path = obj.passport_pic_path;
      this.form.passport_pic_name = obj.passport_pic_name;
    },
    uploadImage() {
      const uploads = [];
      if (this.profile_file) {
        this.upload = "Processing...";
        const data = new FormData();
        data.append('file', this.profile_file);
        uploads.push(
          ApiService.post('/images/store', data)
            .then((response) => {
              this.form.passport_pic_path = response.data.path;
              this.form.passport_pic_name = response.data.name;
            })
        );
      }
      if (this.ghana_card_front_file) {
        this.upload = "Processing...";
        const data = new FormData();
        data.append('file', this.ghana_card_front_file);
        uploads.push(
          ApiService.post('/images/store', data)
            .then((response) => {
              this.form.gh_card_front_path = response.data.path;
              this.form.gh_card_front_name = response.data.name;
            })
        );
      }
      if (this.ghana_card_back_file) {
        this.upload = "Processing...";
        const data = new FormData();
        data.append('file', this.ghana_card_back_file);
        uploads.push(
          ApiService.post('/images/store', data)
            .then((response) => {
              this.form.gh_card_back_path = response.data.path;
              this.form.gh_card_back_name = response.data.name;
            })
        );
      }
      if (this.signature_file) {
        this.upload = "Processing...";
        const data = new FormData();
        data.append('file', this.signature_file);
        uploads.push(
          ApiService.post('/images/store', data)
            .then((response) => {
              this.form.signature_image_path = response.data.path;
              this.form.signature_image_name = response.data.name;
            })
        );
      }

      // Return Promise.all to wait for all uploads to complete
      return uploads.length
        ? Promise.all(uploads)
          .then(() => {
            this.upload = "Uploaded";
          })
          .catch((error) => {
            this.upload = "Failed";
            throw new Error("File upload failed: " + error.message);
          })
        : Promise.resolve();
    },
    onProfilePictureUpload(event) {
      this.profile_file = event[0];
    },
    onGhanaCardFrontUpload(event) {
      this.ghana_card_front_file = event[0];
    },
    onGhanaCardBackUpload(event) {
      this.ghana_card_back_file = event[0];
    },
    onSignatureUpload(event) {
      this.signature_file = event[0];
    },
    removeFile(dropzoneType) {
      let dropzone;
      switch (dropzoneType) {
        case 'profile':
          dropzone = this.$refs.profileDropzone;
          break;
        case 'ghanaCardFront':
          dropzone = this.$refs.ghanaCardFrontDropzone;
          break;
        case 'ghanaCardBack':
          dropzone = this.$refs.ghanaCardBackDropzone;
          break;
        case 'signature':
          dropzone = this.$refs.signatureDropzone;
        case 'incorporationCertificate':
          dropzone = this.$refs.inncoporateDropzone;
          break;
        case 'commerncementCertificate':
          dropzone = this.$refs.commencementDropzone;
          break;
      }

      if (dropzone && dropzone.dropzone.files.length > 0) {
        // Remove all files
        dropzone.dropzone.removeAllFiles();
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>